module.exports = __webpack_public_path__ + "img/Yunnan-speed.3b11bf12.png";